/**
 * web-auth.js — autenticazione web dell'app Capacitor.
 *
 * Caricato SOLO dalla shell PHP (window.TY_WEB = true), DOPO tutti gli script
 * nativi e dopo js/web.js. La shell PHP serve anche l'app nativa Capacitor:
 * lì gli override della sezione 11 delegano alle versioni native (SQLite,
 * browser tab, reload con i parametri del loader).
 *
 * Responsabilità (porting fedele da frontend/webapp/src — settings.js,
 * mobile.js, app.js, all_scr_config.js):
 *  0. cookie utils + sessione web: teyuto_session / ?tok= / ?token= letti a
 *     parse time (prima del boot dell'app, che sul web ha una SQLite shim vuota)
 *  1. pagine auth in-page: login, register, recover(+newPassword), mytv
 *  2. override dei flussi nativi (generateAndHandleNewToken, openModalLogin,
 *     ensureAfterLogin, openLink*, deactivateTheAccount, logoutFromAccount)
 *  3. login/registrazione/recupero password/nuova password/2FA/verifica email
 *  4. SSO Auth0/Clerk via /v2/oauth/login (con cookie teyuto_ref e ritorno ?tok=)
 *  5. broker OAuth per l'APP NATIVA (?app=1&auth_token=XX): dopo il login
 *     GET /v2/sessions/mobile/token?auth_token=XX → il backend spara l'evento
 *     Pusher 'login' sul canale app-auth-XX; in più redirect custom-scheme
 *     <playstore_id>://login?token=<token> (gestito da handleOpenURL nativo)
 *  6. pairing MyTV (/mytv): check codice + POST /v2/mytv/auth via cookie
 *     teyuto_tv_code
 *  7. router deep-link tyWebAuthRoute(path, qs) usato da js/web.js
 */

/* ------------------------------------------------------------------ *
 * 0a. Cookie utils (porting da webapp all_scr_config.js — sul nativo
 *     non esistono: qui sono definite come globali per tutto il web)
 * ------------------------------------------------------------------ */

function readCookie(name) {
    var cookiename = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") c = c.substring(1, c.length);
        if (c.indexOf(cookiename) == 0) {
            return c.substring(cookiename.length, c.length);
        }
    }
    return null;
}

function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
    }
    var isHttps = (location.protocol === 'https:' ||
        location.hostname.includes('railway.app') ||
        location.hostname.includes('teyuto.tv'));
    var secureFlag = isHttps ? "; secure" : "";
    var sameSiteFlag = "; SameSite=Lax";
    document.cookie = name + "=" + (value || "") + expires + "; path=/" + secureFlag + sameSiteFlag;
}

function deleteCookie(name) {
    var isHttps = (location.protocol === 'https:' ||
        location.hostname.includes('railway.app') ||
        location.hostname.includes('teyuto.tv'));
    var secureFlag = isHttps ? "; secure" : "";
    document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;" + secureFlag;
}

function deleteAllCookies() {
    const cookies = document.cookie.split(";");
    for (let cookie of cookies) {
        const cookieName = cookie.split("=")[0].trim();
        document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
        document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${window.location.hostname};`;
        document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.${window.location.hostname};`;
    }
    return cookies.length;
}

// tutto ciò che sta dopo "ref=" nell'URL (porting webapp getRefContent):
// serve per il cookie teyuto_ref prima del redirect SSO
function getRefContent() {
    const url = window.location.href;
    const refIndex = url.indexOf('ref=');
    if (refIndex !== -1) {
        return url.slice(refIndex + 4);
    }
    return null;
}

/* ------------------------------------------------------------------ *
 * 0b. Sessione web — eseguito SUBITO a parse time, prima che il boot
 *     dell'app faccia la fetch dell'utente (sul web la SQLite è una shim
 *     vuota: il cookie è la fonte di verità della sessione)
 * ------------------------------------------------------------------ */
(function () {
    var returnedToken = getUrlParameter('tok') || getUrlParameter('token');
    var brokerToken = getUrlParameter('auth_token');
    var previousBrokerToken = readCookie('auth_token');

    // "fix login bug" (webapp mobile.js): la pagina di login/register aperta
    // dall'app nativa (?app=1) parte SEMPRE da sessione pulita
    if (!returnedToken && getUrlParameter('app') == '1' &&
        (/^(\/app)?\/(login|register)/.test(window.location.pathname))) {
        deleteAllCookies();
        userToken = null;
        try { localStorage.removeItem('ty_websql_info'); } catch (e) {}
    }

    // compat webapp all_scr_config.js: ?tok= (ritorno SSO) e ?token=
    if (returnedToken) {
        userToken = returnedToken;
        setCookie('teyuto_session', userToken, 1000);
        // Il boot legge lo shim SQLite: non deve ripristinare una sessione precedente.
        try {
            var info = JSON.parse(localStorage.getItem('ty_websql_info')) || {};
            info.token = userToken;
            localStorage.setItem('ty_websql_info', JSON.stringify(info));
        } catch (error) {
            console.error('Unable to persist returned login session', error);
        }
    } else if (readCookie('teyuto_session')) {
        // sessione persistita: va in userToken PRIMA della fetch utente
        userToken = readCookie('teyuto_session');
    }

    // broker per l'app nativa: l'auth_token random va persistito in cookie
    // (come switchView della webapp) così sopravvive al giro SSO
    if (brokerToken) {
        setCookie('auth_token', brokerToken, 1000);
        var appScheme = getUrlParameter('app_scheme');
        if (appScheme && /^[A-Za-z][A-Za-z0-9+.-]*$/.test(appScheme) &&
            !/^(https?|javascript|data|file|intent)$/i.test(appScheme)) {
            setCookie('app_scheme', appScheme, 1000);
        } else if (appScheme || !returnedToken || brokerToken !== previousBrokerToken) {
            deleteCookie('app_scheme');
        }
    }
})();

/* ------------------------------------------------------------------ *
 * 1. Contenitori pagina (solo web) dentro .sectionContainer
 * ------------------------------------------------------------------ */

// La classe extra pageMob-auth mantiene compatibile il CSS custom dei canali
// (la webapp renderizzava tutte le viste auth dentro .pageMob-auth)
function tyWebAuthEnsureContainers() {
    var $section = $('.sectionContainer');
    if (!$section.length) { return false; }
    if (!$('.pageMob-login').length) {
        $section.append(`
            <div class="pageMob pageMob-auth pageMob-login"></div>
            <div class="pageMob pageMob-auth pageMob-register"></div>
            <div class="pageMob pageMob-auth pageMob-recover"></div>
            <div class="pageMob pageMob-auth pageMob-mytv"></div>
        `);
    }
    return true;
}

/* ------------------------------------------------------------------ *
 * 2. Viste (porting 1:1 da webapp settings.js — stessi id/classi così il
 *    CSS custom dei canali continua a funzionare)
 * ------------------------------------------------------------------ */

function tyWebGenerateLoginView() {
    return `
        <div class="row pa-1 form-container-md bg-dark pa-2">
            <h4 class="register-text mt-2 white bold">${translate("LOGIN")}</h4>
            <form id="loginForm" method="POST" class="form-login" role="form">
                <input type="hidden" name="reflink" id="reflink" value="${window.location.pathname + window.location.search}">
                <input type="hidden" name="cid" value="${companyId}">

                <div class="form-group mt-2">
                    <input type="email" id="email" name="email" placeholder="Email" class="form-control" required>
                    <label class="form-label">Email</label>
                </div>

                <div class="form-group mt-2">
                    <input type="password" id="password" name="password" placeholder="Password" class="form-control" required>
                    <label class="form-label">Password</label>
                </div>

                <div id="two-factor-auth" style="display:none;"></div>

                <div class="col-md-12 text-right padding-0">
                    <button type="submit" id="login_btn" class="button-primary button-full">${translate("LOGIN")}</button>
                    <button type="button" onclick="tyWebAuthShow('register');" class="button-void button-full mt-2">${translate("REGISTER")}</button>
                </div>
            </form>

            <div class="col-md-12 text-center box_recovery_password mt-2">
                <button type="button" onclick="tyWebAuthShow('recovery');" class="btn-remember-psw btn-transparent btn-xs">
                    ${translate("RECOVERY_PASSWORD")}
                </button>
            </div>
            ${companyLoginSkippable
                ? `<button onclick="navigateToPage('home');" class="button-void mt-2 mb-2 button-full">${translate("SKIP")}</button>`
                : ``}
            <div class="mt-3 gray text-center ty-auth-legal" style="font-size:12px;">
                <span class="bold white" onclick="openLinkTos();">${translate('TERMS_AND_CONDITIONS')}</span> - <span class="bold white" onclick="openLinkPrivacy();">${translate('PRIVACY_POLICY')}</span>
            </div>
        </div>
    `;
}

function tyWebGenerateRegisterView() {
    return `
        <div class="row form-container-md bg-dark pa-2">
            <h4 class="register-text mt-2 white bold">${translate("REGISTER")}</h4>
            <form id="registerForm" method="POST" class="form-register" role="form">
                <input type="hidden" name="reflink" id="reflink" value="${window.location.pathname + window.location.search}">
                <input type="hidden" name="id_company" value="${companyId}">

                <div class="form-group mt-2">
                    <input class="form-control" type="email" id="reg_email" name="email" placeholder="Email" ${getUrlParameter('email') ? `value="${getUrlParameter('email')}"` : ''} required>
                    <label class="form-label">Email</label>
                </div>

                <div class="form-group mt-2">
                    <input class="form-control" type="password" id="reg_password" name="password" placeholder="Password (${translate("PASSWORD_REQUIREMENTS")})" required>
                    <label class="form-label">Password</label>
                    <span toggle="#reg_password" class="ri-eye-line show-hide-passw toggle-password"></span>
                    <span id="passwdControll" class="xbold"></span>
                </div>

                <div class="col-md-12 mb-2 padding-0">
                    <label class="checkbox style-e">
                        <input type="checkbox" name="checkBoxTermsAndCondition" id="checkBoxTermsAndCondition" value="1">
                        <div id="checkBoxTermsAndConditionLabel" class="checkbox__body white" style="font-size: 12px;">
                            ${translate("BY_REGISTERING_AGREE")}
                            <a onclick="openLinkTos()" class="white">${translate("TERMS_AND_CONDITIONS")}</a>
                            ${translate("AND_THE")}
                            <a onclick="openLinkPrivacy()" class="white">${translate("PRIVACY_POLICY")}</a>
                        </div>
                        <div class="checkbox__checkmark"></div>
                    </label>
                </div>

                <div class="col-md-12 text-right padding-0">
                    <button type="submit" class="button-primary button-full registerButton" disabled>
                        ${translate("REGISTER")}
                    </button>
                    <button type="button" onclick="tyWebAuthShow('login');" class="button-void mt-2 mb-2 button-full">${translate("LOGIN")}</button>
                </div>
            </form>
        </div>
    `;
}

function tyWebGenerateRecoveryView() {
    return `
        <div class="row form-container-md bg-dark pa-2">
            <h4 class="register-text mt-2 white bold">${translate("PASSWORD_RECOVERY")}</h4>
            <div id="div_recover_psw" class="mt-2">
                <p class="text-center">${translate("ENTER_EMAIL")}</p>
                <div class="form-group mt-2">
                    <input class="form-control" type="email" id="recovery_email" name="email" placeholder="Email" required>
                    <label class="form-label">Email</label>
                </div>
                <div id="recovery_email_response"></div>
                <div class="text-right mt-2">
                    <button type="button" onclick="tyWebAuthShow('login');" class="button-void">${translate("BACK")}</button>
                    <button id="button_recoverpsw" class="button-primary">${translate("RECOVER")}</button>
                </div>
                <div id="form_recoverpsw_error" class="mb-1 text-center bold"></div>
            </div>
        </div>
    `;
}

function tyWebGenerateNewPasswordView() {
    return `
        <div class="row form-container-md bg-dark pa-2">
            <h4 class="register-text mt-2 white bold">${translate("CHANGE_PASSWORD")}</h4>
            <form id="changePasswordForm" method="POST" class="form-change-password" role="form">

                <div class="form-group mt-2">
                    <input class="form-control" type="password" id="new_password" name="new_password" placeholder="${translate("NEW_PASSWORD")}" required>
                    <label class="form-label">${translate("NEW_PASSWORD")}</label>
                    <span toggle="#new_password" class="ri-eye-line show-hide-passw toggle-password"></span>
                    <span id="newPasswdControl" class="xbold"></span>
                </div>

                <div class="form-group mt-2">
                    <input class="form-control" type="password" id="confirm_password" name="confirm_password" placeholder="${translate("CONFIRM_NEW_PASSWORD")}" required>
                    <label class="form-label">${translate("CONFIRM_NEW_PASSWORD")}</label>
                    <span toggle="#confirm_password" class="ri-eye-line show-hide-passw toggle-password"></span>
                </div>

                <div class="col-md-12 text-right mt-3">
                    <button type="submit" id="change_password_btn" class="button-primary" disabled>
                        ${translate("SAVE")}
                    </button>
                </div>
            </form>
        </div>
    `;
}

function tyWebGenerateVerifyEmailView() {
    return `
        <div class="row form-container-md bg-dark pa-2">
            <div class="bg-dark-login card2 text-center row animated fadeIn pa-3">
                <p class="bold white" style="font-size: 18px;">${translate("PLEASE_VERIFY_YOUR_EMAIL_ADDRESS")}<br>${(userData && userData.email) ? userData.email : ''}</p>
                <p>${translate("PLEASE_VERIFY_YOUR_EMAIL_ADDRESS2")}</p>

                <div class="col-md-12 mt-3">
                    <a class="button-primary" href="/">${translate("I_HAVE_ALREADY_VERIFIED_EMAIL")}</a>

                    <form id="sendValidationEmail" method="POST" class="mt-4" role="form">
                        <button id="send_email_btn" class="bold button-secondary white">${translate("PLEASE_VERIFY_YOUR_EMAIL_ADDRESS3")}</button>
                    </form>

                    <div class="mt-4 bold" id="messageStatus"></div>
                </div>
            </div>
        </div>
    `;
}

function tyWebGeneratePostSignupView() {
    return `
        <div class="pa-2 form-container-md bg-dark row">
            <h4 class="register-text mt-2 white bold pa-1">${translate("MORE_ABOUT_YOU")}</h4>

            <form id="post-signup-form" method="POST" class="form-post-signup" role="form">
                <input type="hidden" name="reflink" id="reflink" value="${window.location.pathname + window.location.search}">
                <input type="hidden" name="id_company" value="${companyId}">
                <input type="hidden" name="cid" value="${companyId}">

                <div class="col-md-12 pa-1 customFieldsPostSignup">
                    <!-- Fields will be dynamically added here -->
                </div>

                <div class="col-md-12 text-right">
                    <button type="button" onclick="tyWebFinishAuth();" class="button-void">
                        ${translate("SKIP")}
                    </button>
                    <button type="submit" class="button-primary">
                        ${translate("SAVE")}
                    </button>
                </div>
            </form>
        </div>
    `;
}

function tyWebGenerateMyTvView() {
    return `
        <div class="pa-2 form-container-md bg-dark row text-center">
            <i class="ri-tv-line" style="font-size:50px;"></i>
            <h4 class="register-text white xbold pa-1 text-center">Access your TV</h4>
            <p class="white">Enter the code you see on your TV</p>
            <form id="post-signup-form" method="POST" class="form-post-signup" role="form">
                <div class="col-md-12 text-right">
                    <input type="text" id="mytv_code" value="${getUrlParameter('code') || ''}" class="form-control" />
                    <br>
                    <button onclick="event.preventDefault(); nextStepMyTv();" type="submit" class="button-primary">
                        ${translate("CONTINUE")}
                    </button>
                </div>
            </form>
        </div>
    `;
}

// conferma in due passi: "Rimuovi account" apre motivo (facoltativo) + Elimina
function tyWebGenerateDeleteAccountView() {
    return `
    <div class="ty-delete-account">
        <form id="removeAccountForm">
            <div class="ty-delete-account-icon"><i class="ri-error-warning-line"></i></div>
            <h3>${translate("DEACTIVATE_ACCOUNT")}</h3>
            <p class="ty-delete-account-text">${translate("ARE_YOU_SURE_DO_YOU_WANT_TO")}</p>

            <div id="btnRemoveAccount" class="ty-delete-account-actions">
                <button type="button" onclick='$("#btnRemoveAccount").hide();$("#whyRemoveAccountProfile").fadeIn(150);$("#messageDeleteAccountProfile").trigger("focus");' class="ty-da-btn ty-da-btn--danger-soft">${translate("DELETE_YOUR_ACCOUNT")}</button>
                <button type="button" onclick="checkGeneralCurrentState();" class="ty-da-btn ty-da-btn--light">${translate("STAY_WITH_US")}</button>
            </div>

            <div id="whyRemoveAccountProfile" class="ty-delete-account-step" style="display:none;">
                <label for="messageDeleteAccountProfile">${translate("WHY_ARE_YOU_DELETING_YOUR_ACCOUNT")}</label>
                <textarea id="messageDeleteAccountProfile" name="message" rows="3"></textarea>
                <div class="ty-delete-account-actions">
                    <button type="button" onclick='$("#whyRemoveAccountProfile").hide();$("#btnRemoveAccount").fadeIn(150);' class="ty-da-btn ty-da-btn--ghost">${translate("CANCEL")}</button>
                    <button type="submit" class="ty-da-btn ty-da-btn--danger"><i class="ri-delete-bin-6-line"></i> ${translate("DELETE")}</button>
                </div>
            </div>
        </form>
    </div>`;
}

function tyWebGenerate2faView() {
    if (!(userData && userData.twofa_configured)) {
        return `
        <div class="text-center fixed_w_s">
            <h3>${translate("CONFIGURE")} 2FA</h3>
            <div id="preCheckBox2FA">
                <h4 class="white mt-1">${translate("PUT_YOUR_PASSWORD")}</h4>
                <div class="form-group mt-2">
                    <input type="password" id="twofa_user_password" name="password" placeholder="Password" class="form-control">
                    <label class="form-label">Password</label>
                </div>
                <button id="save2FAbtn" class="button-primary me-2 mt-2" onclick="event.preventDefault(); check2FA();">${translate("VERIFICATION")}</button>
            </div>
            <div id="2FAresult"></div>
            <div id="saveBox2FA" style="display: none;">
                <h4 class="white">1. ${translate("SCAN_QR_CODE_ON_YOUR_GOOGLE_AUTHENTICATOR_APP")}.</h4>
                <h4 class="white">2.${translate("ENTER_THE_GENERATED_CODE_HERE")}:</h4>
                <input class="form-control" type="text" id="twofa_code">
                <button id="save2FAbtn" class="button-primary me-2 mt-2" onclick="event.preventDefault(); save2FA();">${translate("CONFIGURE")} 2FA</button>
            </div>
        </div>`;
    } else {
        return `
        <div class="text-center fixed_w_s">
            <h3>${translate("REMOVE")} 2FA</h3>
            <div id="preCheckBox2FA">
                <h4 class="mt-1 white">${translate("PUT_YOUR_PASSWORD")}</h4>
                <div class="form-group mt-2">
                    <input type="password" id="twofa_user_password_remove" name="password" placeholder="Password" class="form-control">
                    <label class="form-label">Password</label>
                </div>
                <button id="remove2FAbtn" class="button-secondary me-2 mt-2" onclick="event.preventDefault(); remove2FA();">${translate("REMOVE")}</button>
            </div>
        </div>`;
    }
}

/* ------------------------------------------------------------------ *
 * 3. switchView web — sceglie il contenitore giusto e gestisce l'SSO
 *    (porting di switchView della webapp)
 * ------------------------------------------------------------------ */

// vista → pagina .pageMob-<type> che la ospita
var TY_WEB_AUTH_VIEW_PAGE = {
    login: 'login',
    register: 'register',
    recovery: 'recover',
    newPassword: 'recover',
    verifyEmail: 'login',
    postSignup: 'register',
    myTv: 'mytv'
};

function tyWebClerkEnabled() {
    return !!(companySettings && companySettings.clerk_enabled);
}

function tyWebAuthShow(view) {

    // Runtime nativo Capacitor: login/register partono SEMPRE in browser tab
    // (flusso nativo browsertabs + broker Pusher), mai in-page né con redirect
    // SSO dentro la webview — vale anche quando l'app nativa carica la shell
    // web (TY_WEB=true). Il ritorno del token passa dal canale Pusher
    // app-auth-<token> e da ensureAfterLogin (qui overridata → cookie).
    if ((view == "login" || view == "register") &&
        typeof tyIsNativeRuntime === 'function' && tyIsNativeRuntime() &&
        typeof tyNativeGenerateAndHandleNewToken === 'function') {
        tyNativeGenerateAndHandleNewToken(view == "register" ? "register" : "login");
        return false;
    }

    // auth0/clerk: come la webapp, login e register vengono delegati a
    // /v2/oauth/login; il ritorno arriva con ?tok= (gestito a parse time)
    if (view == "newPassword" && companyAuth0Enabled) {
        redirectToAuth0ResetPassword();
        return false;
    }

    if ((view == "login" || view == "register") && (companyAuth0Enabled || tyWebClerkEnabled())) {
        // Safety guard: senza companyId la /oauth/login risponde 400
        if (!companyId) {
            console.warn("tyWebAuthShow: skip oauth redirect, companyId missing");
            return false;
        }

        var typeAuthTemp = '';
        if (companyAuth0Enabled) { typeAuthTemp = 'auth0'; }
        if (tyWebClerkEnabled()) { typeAuthTemp = 'clerk'; }

        var moreParam = "";
        if (view == "register") {
            moreParam += "&registration=1";
        }

        // prima del redirect il ref viene salvato in cookie (1 ora)
        if (getUrlParameter('ref')) {
            setCookie("teyuto_ref", getRefContent(), 0.0416);
        }

        var oauthUrl =
            URL_API2 + "/oauth/login?id=" + companyId +
            "&type=" + typeAuthTemp + "&" +
            window.location.search.substring(1) + moreParam;
        tyWebRenderAppReturn('redirect', oauthUrl);
        window.location.href = oauthUrl;

        return false;
    }

    // 2FA e cancellazione account vivono nella modal generica (pattern nativo)
    if (view == 'twofa' || view == 'deleteAccount') {
        if (currentPageState[currentPageState.length - 1] != 'modal-generic') {
            addPageToState('modal-generic');
        }
        var htmlModal = (view == 'twofa') ? tyWebGenerate2faView() : tyWebGenerateDeleteAccountView();
        $('#modal-body-generic').html(htmlModal);
        try { BSLight.ModalShow('#modal-generic'); } catch (e) {}
        tyWebAuthBindEvents();
        return true;
    }

    var views = {
        login: tyWebGenerateLoginView,
        register: tyWebGenerateRegisterView,
        recovery: tyWebGenerateRecoveryView,
        newPassword: tyWebGenerateNewPasswordView,
        verifyEmail: tyWebGenerateVerifyEmailView,
        postSignup: tyWebGeneratePostSignupView,
        myTv: tyWebGenerateMyTvView
    };
    if (!views[view]) { return false; }
    if (!tyWebAuthEnsureContainers()) { return false; }

    var page = TY_WEB_AUTH_VIEW_PAGE[view];
    $('.pageMob-' + page).html(views[view]());
    navigateToPage(page);

    if (view === "postSignup") {
        tyWebLoadUserCustomFields(".customFieldsPostSignup");
    }

    tyWebAuthBindEvents();
    return true;
}

/* ------------------------------------------------------------------ *
 * 4. Custom fields post-signup (porting webapp loadUserCustomFields)
 * ------------------------------------------------------------------ */

function tyWebPostSignupRequired() {
    try {
        var s = companySettings || {};
        var cfUser = (s.custom_fields && s.custom_fields.user) || [];
        return s.require_full_name === true || s.require_full_name === 1 ||
            s.email_marketing_enabled === true || s.email_marketing_enabled === 1 ||
            cfUser.length > 0;
    } catch (e) {
        return false;
    }
}

function tyWebLoadUserCustomFields(el) {
    var $customFields = $(el);
    if (!$customFields.length) { return; }
    var s = companySettings || {};

    if (s.require_full_name == 1 || s.require_full_name == true) {
        var fullnameValue = (userData && userData.full_name) || '';
        $customFields.append(`
            <div class="form-group mt-2">
                <input type="text" name="fullname" value="${fullnameValue}" placeholder="${translate("FULL_NAME")}" class="form-control">
                <label class="form-label">${translate("FULL_NAME")}</label>
            </div>
        `);
    }

    try {
        var mdUser = (s.custom_fields && s.custom_fields.user) || [];
        mdUser.forEach(function (field) {
            var value = '';
            try {
                var found = (userData && userData.custom_fields || []).find(function (f) { return f.key === field.key; });
                if (found && found.value) { value = found.value; }
            } catch (e) {}
            $customFields.append(`
                <div class="form-group mt-2">
                    <input type="text" name="${field.key}" value="${value}" placeholder="${field.label}" class="form-control">
                    <label class="form-label">${field.label}</label>
                </div>
            `);
        });
    } catch (e) {
        console.error("Error adding custom fields:", e);
    }

    if (s.email_marketing_enabled == 1 || s.email_marketing_enabled == true) {
        var isChecked = (userData && userData.email_marketing) ? 'checked' : '';
        $customFields.append(`
            <label class="checkbox style-e">
                <input type="checkbox" name="email_news" id="email_news" value="1" ${isChecked}>
                <div class="checkbox__body white" style="font-size: 12px;">
                    ${translate("YES_I_WANT_TO_RECEIVE_NEWS_AND_UPDATES_VIA_EMAIL")}
                </div>
                <div class="checkbox__checkmark"></div>
            </label>
        `);
    }
}

/* ------------------------------------------------------------------ *
 * 5. Validazioni (porting webapp, con nomi tyWeb* per evitare collisioni)
 * ------------------------------------------------------------------ */

function tyWebValidateNewPassword() {
    const password = $("#new_password").val();
    const $passwdControl = $("#newPasswdControl");
    const strongRegex = new RegExp("(?=.{8,})");

    if (!strongRegex.test(password)) {
        $passwdControl.html(
            `<i class="ri-close-line"></i> ${translate("PASSWORD_NOT_VALID")} (${translate("PASSWORD_REQUIREMENTS")})`,
        );
        $passwdControl.css("color", "#F16C5C");
        $("#change_password_btn").prop("disabled", true);
    } else {
        $passwdControl.html('<i class="ri-check-line"></i> Password OK');
        $passwdControl.css("color", "#ADF15C");
        tyWebValidatePasswordMatch();
    }
}

function tyWebValidatePasswordMatch() {
    const newPassword = $("#new_password").val();
    const confirmPassword = $("#confirm_password").val();
    const strongRegex = new RegExp("(?=.{8,})");

    $("#change_password_btn").prop(
        "disabled",
        !(strongRegex.test(newPassword) && newPassword === confirmPassword),
    );
}

function tyWebValidatePassword(password) {
    const strongRegex = new RegExp("(?=.{8,})");
    const $passwdControll = $("#passwdControll");
    const $registerButton = $(".registerButton");

    if (!strongRegex.test(password)) {
        $passwdControll.html(
            `<i class="ri-close-line"></i> ${translate("PASSWORD_NOT_VALID")} (${translate("PASSWORD_REQUIREMENTS")})`,
        );
        $passwdControll.css("color", "#F16C5C");
        $registerButton.prop("disabled", true);
    } else {
        $passwdControll.html('<i class="ri-check-line"></i> Password OK');
        $passwdControll.css("color", "#ADF15C");
        tyWebValidateRegistrationForm();
    }
}

function tyWebValidateRegistrationForm() {
    const password = $("#reg_password").val();
    const email = $("#reg_email").val();
    const termsChecked = $("#checkBoxTermsAndCondition").is(":checked");
    const strongRegex = new RegExp("(?=.{8,})");

    $(".registerButton").prop(
        "disabled",
        !(termsChecked && strongRegex.test(password) && email.length > 0),
    );
}

/* ------------------------------------------------------------------ *
 * 6. Bind eventi form (porting webapp bindLoginEvents)
 * ------------------------------------------------------------------ */

function tyWebAuthBindEvents() {

    // Login (POST /v2/sessions/authentication, body JSON; gestisce 2fa_required)
    $("#loginForm")
        .off("submit")
        .on("submit", function (e) {
            e.preventDefault();
            const email = $("#email").val();
            const password = $("#password").val();
            var payload = { email: email, password: password };

            if ($("#twofa_code").length) {
                payload.twofa_code = $("#twofa_code").val();
            }

            saveSpinnerState("#login_btn", false);

            $.ajax({
                type: "POST",
                url: `${URL_API2}/sessions/authentication`,
                data: JSON.stringify(payload),
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                success: function (json) {
                    let objJson = json;
                    if (objJson.status == 200) {
                        if (objJson.type == "2fa_required") {
                            $("#email").attr("disabled", "disabled");
                            $("#password").attr("disabled", "disabled");
                            $("#two-factor-auth").append(
                                `<div class="form-group mt-2">
                                    <input type="text" id="twofa_code" name="twofa_code" placeholder="Two-Factor code" class="form-control" required>
                                    <label class="form-label">Two-Factor code</label>
                                </div> `,
                            );
                            $("#two-factor-auth").show();
                            $("#login_btn").html(translate("LOGIN"));
                            $("#login_btn").prop("disabled", false);
                        } else {
                            ensureAfterLogin(objJson.auth_token);
                        }
                    }
                    saveSpinnerState("#login_btn", true);
                },
                error: function (data) {
                    var type = data && data.responseJSON && data.responseJSON.type;
                    if (type == "bad_request") {
                        open_notifications_toast(translate("ERROR"), "rgba(192, 57, 43, 1)");
                    } else if (type == "too_many_attempts") {
                        open_notifications_toast(translate("TOO_MANY_ATTEMPS"), "rgba(192, 57, 43, 1)");
                    } else {
                        open_notifications_toast(translate("CHECK_YOUR_DATA"), "rgba(192, 57, 43, 1)");
                    }
                    saveSpinnerState("#login_btn", true);
                },
            });
        });

    // Registrazione (POST /v1/user/?f=register, FormData come la webapp)
    $("#registerForm")
        .off("submit")
        .on("submit", function (e) {
            e.preventDefault();
            const formData = new FormData(this);

            saveSpinnerState(".registerButton", false);

            $.ajax({
                type: "POST",
                url: `${URL_API}/user/?f=register`,
                data: formData,
                processData: false,
                contentType: false,
                success: function (json) {
                    saveSpinnerState(".registerButton", true);

                    let objJson = JSON.parse(json);
                    if (objJson[0].status == "success") {

                        tyWebSetSession(objJson[0].token);

                        //gtm (solo se il canale ha GTM configurato via codici marketing)
                        try {
                            if (typeof gtmConfigured !== 'undefined' && gtmConfigured) {
                                dataLayer.push({ event: "Lead" });
                            }
                        } catch (err) {}

                        if (tyWebPostSignupRequired() == true) {
                            tyWebAuthShow("postSignup");
                        } else {
                            tyWebFinishAuth();
                        }
                    } else {
                        if (objJson[0].type == "empty_fields") {
                            open_notifications_toast(translate("EMPTY_FIELDS"), "rgba(192, 57, 43, 1)");
                        } else if (objJson[0].type == "email_wrong") {
                            open_notifications_toast("Email not valid", "rgba(192, 57, 43, 1)");
                        } else if (objJson[0].type == "password_wrong") {
                            open_notifications_toast("Password wrong", "rgba(192, 57, 43, 1)");
                        } else if (objJson[0].type == "email_already_registerd") {
                            open_notifications_toast(translate("ALREADY_REGISTERED"), "rgba(192, 57, 43, 1)");
                        } else if (objJson[0].type == "too_many_attempts") {
                            open_notifications_toast("To many attemps", "rgba(192, 57, 43, 1)");
                        } else if (objJson[0].type == "registration_not_allowed") {
                            open_notifications_toast(translate("REGISTRATION_NOT_ALLOWED"), "rgba(192, 57, 43, 1)");
                        } else if (objJson[0].type == "check_terms_and_conditions") {
                            open_notifications_toast(translate("CHECK_TERMS_AND_CONDITIONS"), "rgba(192, 57, 43, 1)");
                        } else {
                            open_notifications_toast(translate("ERROR"), "rgba(192, 57, 43, 1)");
                        }
                    }
                },
            });
        });

    // Recupero password (POST /v1/user/?f=request_change_password)
    $("#button_recoverpsw")
        .off("click")
        .on("click", function () {
            if (companyAuth0Enabled) {
                redirectToAuth0ResetPassword();
                return;
            }

            const email = $("#recovery_email").val();

            if (!email) return;
            $("#recovery_email_response").html("");
            $.ajax({
                type: "POST",
                url: `${URL_API}/user/?f=request_change_password`,
                data: { email: email },
                success: function (json) {
                    var obj = JSON.parse(json);
                    var status = obj.status;
                    if (status == "success") {
                        $("#recovery_email_response").html(translate("CHECK_EMAIL"));
                    } else {
                        $("#recovery_email_response").html(translate("NO_EMAIL"));
                    }
                },
                error: function (error) {},
            });
        });

    // Post-signup (POST /v1/user/?f=save_settings&post-signup=1)
    $("#post-signup-form")
        .off("submit")
        .on("submit", function (e) {
            e.preventDefault();
            const formData = new FormData(this);

            $.ajax({
                type: "POST",
                url: `${URL_API}/user/?f=save_settings&post-signup=1`,
                data: formData,
                cache: false,
                contentType: false,
                processData: false,
                success: function () {
                    tyWebFinishAuth();
                },
                error: function () {
                    open_notifications_toast("Error", "rgba(0, 194, 59, 0.8)");
                },
            });
        });

    // Nuova password (POST /v1/user/?f=set_new_password, con hash dall'URL)
    $("#new_password").off("keyup").on("keyup", tyWebValidateNewPassword);
    $("#confirm_password").off("keyup").on("keyup", tyWebValidatePasswordMatch);

    $("#changePasswordForm")
        .off("submit")
        .on("submit", function (e) {
            e.preventDefault();

            if (companyAuth0Enabled) {
                redirectToAuth0ResetPassword();
                return;
            }

            const newPassword = $("#new_password").val();

            saveSpinnerState("#change_password_btn", false);

            let data = {
                new_password: newPassword
            };

            const hash = tyWebNewPasswordHash || getUrlParameter('hash');
            if (hash) {
                data.hash = hash;
            }

            $.ajax({
                type: "POST",
                url: `${URL_API}/user/?f=set_new_password`,
                data: data,
                success: function (response) {
                    const objJson = JSON.parse(response);

                    if (objJson.status === "success") {
                        open_notifications_toast(
                            translate("PASSWORD_CHANGED_SUCCESSFULLY"),
                            "rgba(0, 194, 59, 0.8)",
                        );
                        if (!(userData && userData.status == 'success')) {
                            tyWebAuthShow('login');
                        } else {
                            navigateToPage('home');
                        }
                    } else {
                        let errorMessage;
                        switch (objJson.type) {
                            case "wrong_current_password":
                                errorMessage = translate("CURRENT_PASSWORD_INCORRECT");
                                break;
                            case "invalid_password":
                                errorMessage = translate("PASSWORD_NOT_VALID");
                                break;
                            default:
                                errorMessage = translate("ERROR");
                        }
                        open_notifications_toast(errorMessage, "rgba(192, 57, 43, 1)");
                    }

                    saveSpinnerState("#change_password_btn", true);
                },
                error: function () {
                    open_notifications_toast(translate("ERROR"), "rgba(192, 57, 43, 1)");
                    saveSpinnerState("#change_password_btn", true);
                },
            });
        });

    // Reinvio email di verifica (POST /v1/user/?f=send_activation_code)
    $("#sendValidationEmail")
        .off("submit")
        .on("submit", function (e) {
            e.preventDefault();
            $.ajax({
                type: "POST",
                url: URL_API + "/user/?f=send_activation_code",
                cache: false,
                contentType: false,
                processData: false,
                success: function (json) {
                    var objJson = JSON.parse(json);
                    if (objJson.status == "success") {
                        $("#messageStatus").html(
                            "<p style='color:green;'>" + translate("EMAIL_SENT_TO_GET_VERIFIED") + "</p>",
                        );
                        $("#send_email_btn").prop("disabled", true);
                    } else {
                        $("#messageStatus").html(
                            "<p style='color:red;'>" + translate("EMAIL_TOO_MUCH_ATTEMPTS") + "</p>",
                        );
                    }
                    $("#messageStatus").show();
                },
            });
        });

    // Cancellazione account (POST /v1/user/?f=remove_account, come la webapp)
    $("#removeAccountForm")
        .off("submit")
        .on("submit", function (e) {
            e.preventDefault();
            let formData = new FormData(this);
            let $submit = $(this).find('button[type="submit"]').prop("disabled", true);
            $.ajax({
                type: "POST",
                url: URL_API + "/user/?f=remove_account",
                cache: false,
                data: formData,
                processData: false,
                contentType: false,
                success: function (json) {
                    let objJson = JSON.parse(json);

                    if (objJson[0].status == "success") {
                        open_notifications_toast(
                            translate("ACCOUNT_REMOVED"),
                            "rgba(0, 194, 59, 0.8)",
                        );
                        deleteAllCookies();
                        localStorage.clear();
                        window.location.replace("/");
                    } else {
                        $submit.prop("disabled", false);
                        open_notifications_toast(
                            objJson[0].status == "not_valid"
                                ? translate("CANCEL_SUBSCRIPTION_BEFORE_DELETE_ACCOUNT")
                                : translate("ERROR") + "!",
                            "rgba(192, 57, 43, 1)",
                        );
                    }
                },
                error: function () {
                    $submit.prop("disabled", false);
                    open_notifications_toast(translate("ERROR") + "!", "rgba(192, 57, 43, 1)");
                },
            });
        });

    // Mostra/nascondi password
    $(".toggle-password")
        .off("click")
        .on("click", function () {
            $(this).toggleClass("ri-eye-line ri-eye-off-line");
            const input = $($(this).attr("toggle"));
            input.attr("type", input.attr("type") === "password" ? "text" : "password");
        });

    // Validazione password registrazione + checkbox termini
    $("#reg_password")
        .off("keyup")
        .on("keyup", function () {
            tyWebValidatePassword($(this).val());
        });

    $("#reg_email")
        .off("keyup")
        .on("keyup", function () {
            tyWebValidateRegistrationForm();
        });

    $("#checkBoxTermsAndCondition")
        .off("change")
        .on("change", function () {
            tyWebValidateRegistrationForm();
        });
}

/* ------------------------------------------------------------------ *
 * 7. SSO Auth0 — reset password (porting webapp)
 * ------------------------------------------------------------------ */

function getAuth0ResetUrl() {
    if (!companyId) {
        return null;
    }
    const queryParams = new URLSearchParams({
        id: companyId,
        type: "auth0",
    });
    return `${URL_API2}/oauth/login?${queryParams.toString()}`;
}

function redirectToAuth0ResetPassword() {
    const auth0LoginUrl = getAuth0ResetUrl();
    if (!auth0LoginUrl) {
        open_notifications_toast(translate("ERROR"), "rgba(192, 57, 43, 1)");
        return false;
    }

    // se l'utente è già loggato prima si chiude la sessione Auth0 (evita
    // il re-login silenzioso)
    var redirectUrl = auth0LoginUrl;
    if (userData && userData.status === "success") {
        redirectUrl = `${URL_API2}/oauth/logout?id=${companyId}&type=auth0&force_logout=1`;
    }

    tyWebRenderAppReturn('redirect', redirectUrl);
    window.location.href = redirectUrl;
    return true;
}

/* ------------------------------------------------------------------ *
 * 8. Sessione, broker app nativa e MyTV
 * ------------------------------------------------------------------ */

function tyWebSetSession(token) {
    setCookie('teyuto_session', token, 1000);
    userToken = token;
    localStorage.clear();
}

// Pagina di stato a tutto schermo con logo/colori del canale: redirect verso
// l'SSO ('redirect') e ritorno all'app nativa ('waiting' | 'ready' | 'error').
// Il pulsante resta come fallback se il redirect automatico non parte (es.
// schema dell'app bloccato senza gesto dell'utente nelle browser tab).
function tyWebRenderAppReturn(state, callbackUrl) {
    var messages = {
        en: {
            APP_RETURN_SUCCESS: "You're signed in",
            APP_RETURN_HELP: "We're opening the app automatically. If it doesn't open, tap the button below and confirm opening the app in your browser.",
            APP_RETURN_OPEN: "Open the app",
            APP_RETURN_WAIT: "Returning to the app",
            APP_RETURN_WAIT_HELP: "Please wait while we complete your sign-in.",
            APP_RETURN_ERROR_TITLE: "We couldn't return to the app",
            APP_RETURN_ERROR_HELP: "Please try again. If the problem continues, return to the app and start signing in again.",
            APP_RETURN_RETRY: "Try again",
            APP_RETURN_REDIRECT: "Redirecting",
            APP_RETURN_REDIRECT_HELP: "Please wait a moment. If nothing happens, tap the button below.",
            APP_RETURN_CONTINUE: "Continue"
        },
        it: {
            APP_RETURN_SUCCESS: "Accesso effettuato",
            APP_RETURN_HELP: "Stiamo aprendo l'app automaticamente. Se non si apre, tocca il pulsante qui sotto e conferma l'apertura nel browser.",
            APP_RETURN_OPEN: "Apri l'app",
            APP_RETURN_WAIT: "Ritorno all'app",
            APP_RETURN_WAIT_HELP: "Attendi mentre completiamo l'accesso.",
            APP_RETURN_ERROR_TITLE: "Non siamo riusciti a tornare all'app",
            APP_RETURN_ERROR_HELP: "Riprova. Se il problema persiste, torna nell'app e avvia nuovamente l'accesso.",
            APP_RETURN_RETRY: "Riprova",
            APP_RETURN_REDIRECT: "Reindirizzamento in corso",
            APP_RETURN_REDIRECT_HELP: "Attendi qualche istante. Se non succede nulla, tocca il pulsante qui sotto.",
            APP_RETURN_CONTINUE: "Continua"
        }
    };
    var language = String(currentLang || 'en').split(/[-_]/)[0].toLowerCase();
    function text(key) {
        var custom = LANGUAGE_LINES && LANGUAGE_LINES[key];
        return typeof custom === 'string' && custom.trim() ? custom : (messages[language] || messages.en)[key];
    }
    var ready = state === 'ready';
    var failed = state === 'error';
    var redirect = state === 'redirect';
    var $page = $('<main class="ty-app-return pageMob-auth"></main>');
    var $card = $('<section class="ty-app-return-card form-container-md text-center"></section>').appendTo($page);
    if (companyLogo) {
        $('<img class="ty-app-return-logo">').attr('src', companyLogo)
            .attr('alt', companyName || '').appendTo($card);
    }
    $('<i class="ty-app-return-icon" aria-hidden="true"></i>')
        .addClass(failed ? 'ri-error-warning-line' : ready ? 'ri-checkbox-circle-line' :
            redirect ? 'ri-login-circle-line' : 'ri-smartphone-line')
        .appendTo($card);
    var $status = $('<div role="status" aria-live="polite"></div>').appendTo($card);
    $('<h1 class="ty-app-return-title"></h1>')
        .text(text(failed ? 'APP_RETURN_ERROR_TITLE' : ready ? 'APP_RETURN_SUCCESS' :
            redirect ? 'APP_RETURN_REDIRECT' : 'APP_RETURN_WAIT'))
        .appendTo($status);
    $('<p class="ty-app-return-description"></p>')
        .text(text(failed ? 'APP_RETURN_ERROR_HELP' : ready ? 'APP_RETURN_HELP' :
            redirect ? 'APP_RETURN_REDIRECT_HELP' : 'APP_RETURN_WAIT_HELP'))
        .appendTo($status);
    if (ready || redirect) {
        $('<a class="button-primary button-full ty-app-return-action"></a>')
            .attr('href', callbackUrl).text(text(ready ? 'APP_RETURN_OPEN' : 'APP_RETURN_CONTINUE')).appendTo($card);
    } else if (failed) {
        $('<button type="button" class="button-primary button-full ty-app-return-action"></button>')
            .text(text('APP_RETURN_RETRY')).on('click', tyWebHandleAppBroker).appendTo($card);
    }
    $('body style').appendTo('head');
    $('body').empty().append($page);
}

// Broker OAuth per l'app nativa: se questa pagina è stata aperta dall'app
// (?app=1&auth_token=XX → cookie auth_token), il token di sessione appena
// creato va riconsegnato all'app. Stesso identico meccanismo della webapp:
//  1. GET /v2/sessions/mobile/token?auth_token=XX (Authorization = sessione):
//     il backend spara l'evento Pusher 'login' {token} sul canale app-auth-XX,
//     a cui l'app nativa è iscritta (vedi generateAndHandleNewToken nativo)
//  2. redirect custom-scheme <playstore_id>://login?token=... come fallback
//     (gestito da handleOpenURL in app.js nativo)
function tyWebHandleAppBroker() {
    var brokerToken = readCookie('auth_token');
    if (!brokerToken || !userToken) {
        return false;
    }
    tyWebRenderAppReturn('waiting');
    $.ajax({
        url: URL_API2 + "/sessions/mobile/token?auth_token=" + encodeURIComponent(brokerToken),
        method: "GET",
        timeout: 15000,
        success: function (response) {
            var sessionToken = userToken;
            var appScheme = readCookie('app_scheme') || (companySettings && companySettings.playstore_id);
            if (!appScheme || !/^[A-Za-z][A-Za-z0-9+.-]*$/.test(appScheme) ||
                /^(https?|javascript|data|file|intent)$/i.test(appScheme)) {
                console.error('App login callback scheme missing or invalid');
                tyWebRenderAppReturn('error');
                return;
            }
            deleteAllCookies();
            var callbackUrl = appScheme + "://login?token=" + encodeURIComponent(sessionToken);
            tyWebRenderAppReturn('ready', callbackUrl);
            window.location.href = callbackUrl;
            return false;
        },
        error: function (xhr, status, error) {
            console.error("Error:", error);
            tyWebRenderAppReturn('error');
        },
    });
    return true;
}

// Pairing MyTV: se c'è un codice TV in attesa (cookie teyuto_tv_code) e una
// sessione valida, POST /v2/mytv/auth {code} — porting webapp mobile.js
function tyWebHandleMyTv() {
    var tvCodeTemp = readCookie('teyuto_tv_code');
    if (!tvCodeTemp || !userToken) {
        return false;
    }
    $.ajax({
        url: URL_API2 + "/mytv/auth",
        method: "POST",
        data: { code: tvCodeTemp },
        success: function (response) {
            deleteAllCookies();
            if (tyWebAuthEnsureContainers()) {
                $('.pageMob-mytv').html('<div class="pa-2 form-container-md bg-dark row text-center"><p class="white"><i class="ri-checkbox-circle-fill" style="color:green;"></i> You have correctly logged in to your TV</p></div>');
                navigateToPage('mytv');
            }
            return false;
        },
        error: function (xhr, status, error) {
            deleteCookie('teyuto_tv_code');
            open_notifications_toast(translate("ERROR"), "rgba(192, 57, 43, 1)");
            console.error("Error:", error);
        },
    });
    return true;
}

// Step 1 del pairing MyTV: verifica del codice, poi login
function nextStepMyTv() {
    let code = ($('#mytv_code').val() || '').trim();
    if (!code) { return false; }
    $.ajax({
        type: "GET",
        url: URL_API2 + `/mytv/${companyId}?code=${encodeURIComponent(code)}&check=true`,
        success: function (response) {
            setCookie("teyuto_tv_code", code, 1000);
            tyWebAuthShow('login');
        },
        error: function (response) {
            open_notifications_toast(translate("ERROR"), "rgba(192, 57, 43, 1)");
        }
    });
}

// Pagine-contenuto da cui può partire il flusso auth (paywall, checkout):
// a login avvenuto si torna lì, da ogni altra pagina si va in home
var TY_WEB_AUTH_RETURN_LAYER = /^(video-|collection-|page-|playlist-|checkout)/;

function tyWebAfterAuthUrl() {
    var authPages = ['login', 'register', 'recover', 'mytv'];
    for (var i = currentPageState.length - 1; i >= 0; i--) {
        var layer = currentPageState[i];
        if (!layer || layer.indexOf('modal') === 0 || authPages.indexOf(layer) !== -1) { continue; }
        if (TY_WEB_AUTH_RETURN_LAYER.test(layer)) { return Nav.urlFor(layer); }
        break;
    }
    return Nav.urlFor('home');
}

// Chiusura del flusso auth: prima il broker app / il pairing TV, poi il ref
// (?ref= come la webapp), altrimenti reload completo — non una navigazione
// in-page: l'app riparte da zero con la sessione nel cookie (home, profilo,
// paywall, Pusher) e i layer login/register escono dalla history
function tyWebFinishAuth() {
    if (tyWebHandleAppBroker()) { return; }
    if (tyWebHandleMyTv()) { return; }

    if (getUrlParameter('ref')) {
        window.location.href = getUrlParameter('ref');
        return;
    }

    window.location.replace(tyWebAfterAuthUrl());
}

/* ------------------------------------------------------------------ *
 * 9. Verifica email (porting webapp checkEmailConfirmation)
 * ------------------------------------------------------------------ */

function checkEmailConfirmation() {
    $.ajax({
        type: "POST",
        url: URL_API + "/user/?f=verify_email",
        data: {
            id: getUrlParameter("id"),
            cod: getUrlParameter("cod"),
        },
        cache: false,
        success: function (json) {
            var objJson = JSON.parse(json);
            if (objJson.status == "success") {
                if (objJson.token) {
                    setCookie("teyuto_session", objJson.token, 1000);
                }
                userToken = objJson.token;

                if (getUrlParameter("ref")) {
                    window.location.replace(getUrlParameter("ref") + "&email_verified=success");
                } else {
                    window.location.replace("/browse?email_verified=success");
                }
            } else if (objJson.status == "user_already_verified") {
                if (getUrlParameter("ref")) {
                    window.location.replace(getUrlParameter("ref") + "&email_verified=user_already_verified");
                } else {
                    window.location.replace("/browse?email_verified=user_already_verified");
                }
            } else {
                window.location.replace("/?email_verified=error");
            }
        },
    });
}

/* ------------------------------------------------------------------ *
 * 10. 2FA (porting webapp save2FA/check2FA/remove2FA)
 * ------------------------------------------------------------------ */

function check2FA() {
    var formData = new FormData();
    formData.append("password", $("#twofa_user_password").val());

    saveSpinnerState("#save2FAbtn", false);

    $.ajax({
        type: "POST",
        url: URL_API2 + "/users/2fa",
        cache: false,
        data: formData,
        contentType: false,
        processData: false,
        success: function (img) {
            $("#preCheckBox2FA").hide();
            $("#2FAresult").html("<img src='" + img + "' >");
            $("#saveBox2FA").show();
            saveSpinnerState("#save2FAbtn", true);
        },
        error: function () {
            saveSpinnerState("#save2FAbtn", true);
            $("#save2FAbtn").html(`${translate("VERIFICATION")}`);
            open_notifications_toast(translate("ERROR") + "!", "rgba(192, 57, 43, 1)");
        },
    });
}

function save2FA() {
    var formData = new FormData();
    formData.append("twofa_code", $("#twofa_code").val());

    saveSpinnerState("#save2FAbtn", false);
    $.ajax({
        type: "POST",
        url: URL_API2 + "/users/2fa/save",
        cache: false,
        data: formData,
        contentType: false,
        processData: false,
        success: function (result) {
            saveSpinnerState("#save2FAbtn", true);
            checkGeneralCurrentState(); //chiude la modal
            open_notifications_toast(translate("SAVED") + "!", "rgb(46, 182, 13)");
        },
        error: function () {
            saveSpinnerState("#save2FAbtn", true);
            open_notifications_toast(translate("ERROR") + "!", "rgba(192, 57, 43, 1)");
        },
    });
}

function remove2FA() {
    var formData = new FormData();
    formData.append("password", $("#twofa_user_password_remove").val());

    saveSpinnerState("#remove2FAbtn", false);

    $.ajax({
        type: "POST",
        url: URL_API2 + "/users/2fa/delete",
        cache: false,
        data: formData,
        contentType: false,
        processData: false,
        success: function (result) {
            saveSpinnerState("#remove2FAbtn", true);
            checkGeneralCurrentState(); //chiude la modal
            open_notifications_toast(translate("SAVED") + "!", "rgb(46, 182, 13)");
        },
        error: function () {
            saveSpinnerState("#remove2FAbtn", true);
            $("#remove2FAbtn").html(`${translate("REMOVE")}`);
            open_notifications_toast(translate("ERROR") + "!", "rgba(192, 57, 43, 1)");
        },
    });
}

/* ------------------------------------------------------------------ *
 * 11. Override dei flussi nativi — ASSEGNAZIONI, non dichiarazioni:
 *     una function declaration verrebbe hoistata a inizio file e
 *     sostituirebbe la versione nativa prima che sia catturabile
 * ------------------------------------------------------------------ */

// La modal login resta quella NATIVA (bottoni LOGIN / JOIN NOW + SKIP se
// companyLoginSkippable) e il redirect SSO/form parte SOLO dal click sui
// suoi bottoni (generateAndHandleNewToken, overridata qui sotto).
// Differenza web vs app: sull'app la modal si apre anche da sola al primo
// accesso; sul WEB no — le chiamate d'ufficio prima di qualsiasi gesto
// dell'utente vengono ignorate (si atterra sulla home guest). Dopo un
// gesto (click su contenuto premium, salvati, ecc.) la modal si apre
// normalmente; i deep-link che richiedono auth usano openModalLogin(true).
var tyNativeOpenModalLogin = openModalLogin;
var tyWebAuthInteracted = false;
['pointerdown', 'keydown', 'touchstart'].forEach(function (ev) {
    document.addEventListener(ev, function () { tyWebAuthInteracted = true; }, { once: true, capture: true });
});

openModalLogin = function (force) {
    if (!tyWebAuthInteracted && force !== true) {
        return false;
    }
    return tyNativeOpenModalLogin();
};

// Nativo: apre una browser tab sul dominio del canale e ascolta Pusher.
// Web: il login È in-page (o redirect SSO) — e questa funzione viene
// invocata SOLO da un click esplicito dell'utente (bottoni della modal
// login, profilo, paywall), mai d'ufficio.
// La versione nativa viene catturata prima dell'override: sul runtime
// Capacitor tyWebAuthShow la usa per aprire login/register in browser tab.
var tyNativeGenerateAndHandleNewToken = generateAndHandleNewToken;
generateAndHandleNewToken = function (type = 'login') {
    // chiude la modal login nativa se aperta, riallineando lo stack Nav
    try {
        if (Nav.top() === 'modal-generic') {
            Nav.dismissTop('modal-generic');
        } else {
            BSLight.ModalHide('#modal-generic');
        }
    } catch (e) {}
    tyWebAuthShow(type == 'register' ? 'register' : 'login');
};

// Nativo: salva il token nella SQLite. Web: cookie teyuto_session (1000gg,
// path=/, secure, SameSite=Lax — vedi setCookie) + broker app/MyTV + refresh.
var tyNativeEnsureAfterLogin = ensureAfterLogin;
ensureAfterLogin = function (token) {
    // app nativa: il token va nella SQLite (Pusher / handleOpenURL)
    if (tyIsNativeRuntime()) {
        return tyNativeEnsureAfterLogin(token);
    }
    tyWebSetSession(token);
    tyWebFinishAuth();
};

openLinkTos = function () {
    if (!companyDocTos) { return false; }
    var url = companyDocTos;
    var separator = (url.indexOf('?') !== -1) ? '&' : '?';
    url += separator + 'l=' + currentLang;
    window.open(url, '_blank');
};

openLinkPrivacy = function () {
    if (!companyDocPrivacy) { return false; }
    var url = companyDocPrivacy;
    var separator = (url.indexOf('?') !== -1) ? '&' : '?';
    url += separator + 'l=' + currentLang;
    window.open(url, '_blank');
};

openSupportEmail = function () {
    if (!companySupportEmail) { return false; }
    window.open('mailto:' + companySupportEmail, '_blank');
};

// Nativo: apre il dominio web con ?action=deactive-account.
// Web: siamo GIÀ sul web → flusso di cancellazione in-page (stessa form e
// stesso endpoint /v1/user/?f=remove_account della webapp).
deactivateTheAccount = function () {
    tyWebAuthShow('deleteAccount');
};

// Nativo: DELETE sessione + cancella il token dalla SQLite + reload.
// Web: senza cancellare il cookie l'utente resterebbe loggato al reload.
var tyNativeLogoutFromAccount = logoutFromAccount;
logoutFromAccount = function () {
    // app nativa: token via dalla SQLite e ritorno alla home mantenendo i
    // parametri del loader (un replace("/") apriva il selettore canale). I
    // cookie vanno via comunque: web.js rileggerebbe teyuto_session al boot
    if (tyIsNativeRuntime()) {
        deleteAllCookies();
        return tyNativeLogoutFromAccount();
    }
    try {
        $.ajax({
            type: "DELETE",
            url: URL_API2 + "/sessions/authentication",
            complete: function () {
                deleteAllCookies();
                localStorage.clear();
                window.location.replace("/");
            },
        });
    } catch (error) {
        deleteAllCookies();
        localStorage.clear();
        window.location.replace("/");
    }
};

/* ------------------------------------------------------------------ *
 * 12. Router deep-link — chiamato da js/web.js (tyWebInitialRoute) con
 *     path = location.pathname e qs = URLSearchParams
 * ------------------------------------------------------------------ */

// hash del link "nuova password" letto dal deep-link (vedi tyWebAuthRoute)
var tyWebNewPasswordHash = null;

function tyWebAuthRoute(path, qs) {
    qs = qs || new URLSearchParams(window.location.search);

    if (path.indexOf('/login') === 0) {
        if (qs.get('force_logout') == '1') {
            deleteAllCookies();
            window.location.replace("/login");
            return false;
        }
        tyWebWhenUser(function () {
            if (userData && userData.status == 'success') {
                // già loggato: eventuale ref, altrimenti resta in home
                if (qs.get('ref')) { window.location.href = qs.get('ref'); }
            } else {
                tyWebAuthShow('login');
            }
        });
        return true;
    }

    if (path.indexOf('/register') === 0) {
        tyWebWhenUser(function () {
            if (userData && userData.status == 'success') {
                if (qs.get('ref')) { window.location.href = qs.get('ref'); }
            } else {
                tyWebAuthShow('register');
            }
        });
        return true;
    }

    if (path.indexOf('/passwordRecover') === 0) {
        tyWebWhenUser(function () {
            if (!(userData && userData.status == 'success')) {
                tyWebAuthShow('recovery');
            }
        });
        return true;
    }

    if (path.indexOf('/newPassword') === 0) {
        // hash salvato subito: aprendo la vista Nav riscrive l'URL su '/'
        tyWebNewPasswordHash = qs.get('hash');
        tyWebAuthShow('newPassword');
        return true;
    }

    if (path.indexOf('/twofa') === 0) {
        tyWebWhenUser(function () {
            if (userData && userData.status == 'success') {
                tyWebAuthShow('twofa');
            } else {
                tyWebAuthShow('login');
            }
        });
        return true;
    }

    if (path.indexOf('/emailConfirmation') === 0) {
        checkEmailConfirmation();
        return true;
    }

    if (path.indexOf('/mytv') === 0) {
        // come la webapp: pairing sempre da sessione pulita, il login viene
        // richiesto dopo la verifica del codice
        localStorage.clear();
        deleteAllCookies();
        userToken = null;
        tyWebAuthShow('myTv');
        return true;
    }

    if (path.indexOf('/deleteAccount') === 0 || path.indexOf('/deactive-account') === 0 ||
        qs.get('action') == 'deactive-account') {
        tyWebWhenUser(function () {
            tyWebAuthShow('deleteAccount');
        });
        return true;
    }

    return false;
}

/* ------------------------------------------------------------------ *
 * 13. Bootstrap on-ready: contenitori, toast email_verified e i check
 *     post-redirect (ritorno SSO / reload con broker o MyTV pendenti)
 * ------------------------------------------------------------------ */

$(function () {

    tyWebAuthEnsureContainers();

    tyWebWhenReady(function () {

        // ritorno SSO: se prima del redirect era stato salvato un ref
        if (readCookie('teyuto_ref')) {
            var refTemp = readCookie('teyuto_ref');
            deleteCookie('teyuto_ref');
            window.location.href = refTemp;
            return;
        }

        // broker app nativa / pairing TV rimasti pendenti dopo un redirect
        // (es. ritorno SSO con ?tok=): con la sessione in mano si chiudono qui
        if (userToken) {
            if (tyWebHandleAppBroker()) { return; }
            tyWebHandleMyTv();
        }
    });

    // esito verifica email via querystring (porting webapp mobile.js)
    var emailVerified = getUrlParameter("email_verified");
    if (emailVerified) {
        tyWebWhenUser(function () {
            if (emailVerified == "success") {
                open_notifications_toast(translate("SUCCESS_ACTIVATION"), "#008000");
            }
            if (emailVerified == "error") {
                open_notifications_toast(translate("ERROR_ACTIVATION"), "#FF0000");
            }
            if (emailVerified == "user_already_verified") {
                open_notifications_toast(translate("ALREADY_ACTIVE_ACCOUNT"), "#FF0000");
            }
        });
    }
});
